import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { parseContent } from '../utils';
import { ProjectErrorType } from '../../utils/errors/types';
import { getProjectErrorFromRawError } from '../../utils/errors';

export interface ChatConfiguration {
  prompt: string;
  temperature: number;
}

export const getChatConfiguration = async (): Promise<ChatConfiguration | null> => {
  try {
    const result = await getDoc(doc(db, 'settings', 'appConfiguration'));
    if (!result.exists()) {
      console.log('No app configuration document found!');
      return null;
    }

    const data = parseContent(result);
    return data?.chat || null;
  } catch (error) {
    console.log('[CHAT CONFIG] Error at getChatConfiguration:', error);
    return null;
  }
};

export const setChatConfiguration = async (chatConfig: ChatConfiguration): Promise<void | ProjectErrorType> => {
  try {
    // Get existing app configuration
    const existingDoc = await getDoc(doc(db, 'settings', 'appConfiguration'));
    let existingData = {};

    if (existingDoc.exists()) {
      existingData = parseContent(existingDoc) || {};
    }

    // Update with new chat configuration
    await setDoc(doc(db, 'settings', 'appConfiguration'), {
      ...existingData,
      chat: chatConfig,
    });
  } catch (error) {
    console.log('[CHAT CONFIG] Error at setChatConfiguration:', error);
    return getProjectErrorFromRawError(error as Error);
  }
};
